import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import { handleKeyDown } from '../../../util/utils'
// import InputTreeSelect from '../../commons/form/InputTreeSelect'

class FinancingModal extends PureComponent {
  constructor () {
    super()
    this.state = {
    }
  }

  submitFinancing (values) {
    const body = {
      ...values
    }
    this.props.actions.submitFinancing(body, this.props.financing)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.showModal !== this.props.showModal && nextProps.showModal === true) {
      this.props.initialize({ ...nextProps.financing })
    }
  }

  render () {
    const {
      t, handleSubmit,
      showModal
      //, combos: { UOTreeCombo }
    } = this.props
    const tKey = 'MASTERS.FINANCING_MASTERS.MODAL.'
    return (
      <Modal id="financingMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeEditFinancingModal}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitFinancing.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeEditFinancingModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editFinancing',
  validate: (values, props) => {
    const error = { financing: {} }
    if (values) {
      const tKey = 'MASTERS.FINANCING_MASTERS.VALIDATION.'
      if (!values.name) {
        error.name = props.t(`${tKey}NAME`)
      }
      if (!values.description) {
        error.description = props.t(`${tKey}DESCRIPTION`)
      }
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(FinancingModal)
